// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StackTecnologica_secao__ucS06 {
  padding: 6rem 1.5rem;
  max-width: 1100px;
  margin: 0 auto;
}

.StackTecnologica_etiqueta__-laPD {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  color: hsl(217, 91%, 60%);
  margin-bottom: 1rem;
  display: block;
  text-align: center;
}

.StackTecnologica_titulo__uKVqo {
  font-size: 2.5rem;
  font-weight: 800;
  color: hsl(210, 40%, 95%);
  margin-bottom: 3rem;
  text-align: center;
}

.StackTecnologica_grade__DRJtJ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
}

.StackTecnologica_categoriaCard__ScSoc {
  background: hsl(222, 44%, 9%);
  border: 1px solid hsl(222, 30%, 18%);
  border-radius: 0.75rem;
  padding: 1.75rem;
  transition: all 0.3s ease;
}

.StackTecnologica_categoriaCard__ScSoc:hover {
  border-color: hsl(217, 91%, 60%, 0.3);
  box-shadow: 0 0 30px hsl(217, 91%, 60%, 0.08);
  transform: translateY(-2px);
}

.StackTecnologica_categoriaNome__ZnEeH {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  color: hsl(217, 91%, 60%);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid hsl(222, 30%, 18%);
}

.StackTecnologica_listaHabilidades__EK4JX {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  list-style: none;
  padding: 0;
  margin: 0;
}

.StackTecnologica_habilidade__rXwIz {
  font-size: 0.85rem;
  color: hsl(215, 20%, 65%);
  background: hsl(222, 30%, 14%);
  padding: 0.4rem 0.85rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
}

.StackTecnologica_habilidade__rXwIz:hover {
  color: hsl(217, 91%, 65%);
  background: hsl(217, 91%, 60%, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/components/StackTecnologica/StackTecnologica.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC","sourcesContent":[".secao {\n  padding: 6rem 1.5rem;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.etiqueta {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 0.8rem;\n  color: hsl(217, 91%, 60%);\n  margin-bottom: 1rem;\n  display: block;\n  text-align: center;\n}\n\n.titulo {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: hsl(210, 40%, 95%);\n  margin-bottom: 3rem;\n  text-align: center;\n}\n\n.grade {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.5rem;\n}\n\n.categoriaCard {\n  background: hsl(222, 44%, 9%);\n  border: 1px solid hsl(222, 30%, 18%);\n  border-radius: 0.75rem;\n  padding: 1.75rem;\n  transition: all 0.3s ease;\n}\n\n.categoriaCard:hover {\n  border-color: hsl(217, 91%, 60%, 0.3);\n  box-shadow: 0 0 30px hsl(217, 91%, 60%, 0.08);\n  transform: translateY(-2px);\n}\n\n.categoriaNome {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 0.8rem;\n  color: hsl(217, 91%, 60%);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin-bottom: 1.25rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid hsl(222, 30%, 18%);\n}\n\n.listaHabilidades {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.habilidade {\n  font-size: 0.85rem;\n  color: hsl(215, 20%, 65%);\n  background: hsl(222, 30%, 14%);\n  padding: 0.4rem 0.85rem;\n  border-radius: 0.5rem;\n  transition: all 0.2s ease;\n}\n\n.habilidade:hover {\n  color: hsl(217, 91%, 65%);\n  background: hsl(217, 91%, 60%, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secao": `StackTecnologica_secao__ucS06`,
	"etiqueta": `StackTecnologica_etiqueta__-laPD`,
	"titulo": `StackTecnologica_titulo__uKVqo`,
	"grade": `StackTecnologica_grade__DRJtJ`,
	"categoriaCard": `StackTecnologica_categoriaCard__ScSoc`,
	"categoriaNome": `StackTecnologica_categoriaNome__ZnEeH`,
	"listaHabilidades": `StackTecnologica_listaHabilidades__EK4JX`,
	"habilidade": `StackTecnologica_habilidade__rXwIz`
};
export default ___CSS_LOADER_EXPORT___;
